// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__3FYIM","menu_icon":"style_menu_icon__34UNP","nav":"style_nav__2TQAC","border-transform":"style_border-transform__2d0v4"};